import React from "react";
import { aiClearHistory } from "../../../../api/api";
import { clearSkillMetrics } from "../../../../state/ai/runMetrics";
import useApi from "../../../../hooks/useApi";
import { useChatHistory } from "../../../../state/api/ai/useChatHistory";
import Button from "../../buttons/Button";
import { abortRun } from "../../../../state/ai/runRegistry";

interface Props {
  skill: string;
  onDelete?: () => void,
}

export default function ClearChatHistoryButton(props: Props) {

  const { onDelete, skill } = props;

  const { chatHistory, mutate } = useChatHistory({ skill }, { enabled: !!skill });

  const callApi = useApi();

  if (!skill || (!onDelete && !chatHistory?.length)) {
    return null;
  }

  return (
    <Button
      color="var(--bs-danger)"
      onClick={async () => {
        abortRun(skill);

        if (chatHistory?.length) {
          clearSkillMetrics(skill);

          await callApi(aiClearHistory({
            skill
          }));

          await mutate(_ => [], { revalidate: false });
        }

        onDelete?.();
      }}
      text="End Chat"
      icon="trash"
    />
  )
}